document.addEventListener("DOMContentLoaded", function () {
  function updateTimeUnits() {
    // 1. Prendiamo TUTTI i timer principali
    const timers = document.querySelectorAll("countdown-timer.countdown-timer--root");
    if (!timers.length) {
      //console.error("Nessun timer trovato");
      return;
    }

    //console.log(`Trovati ${timers.length} timer`);

    // Cicliamo su ogni timer
    timers.forEach((timer, timerIndex) => {
      //console.group(`Timer ${timerIndex + 1}`);
      const dataexpirydate = timer.getAttribute("data-expiry-date");
      if (dataexpirydate === "DD-MM-YYYY") {return;}
      // 2. Troviamo tutti gli item (giorni, ore, minuti, secondi) per QUESTO timer
      const items = timer.querySelectorAll(".countdown-timer--item");
      const viewtype = timer.getAttribute("data-view");
      //console.log(`Trovati ${items.length} elementi temporali`);

      // 3. Analizziamo ogni item
      items.forEach((item, index) => {
        const type = ["Giorni", "Ore", "Minuti", "Secondi"][index] || `Item ${index + 1}`;
        //console.group(`Analisi ${type}`);

        // 4. Troviamo il container delle cifre
        const digitsContainer = item.querySelector(".countdown-timer--digits");
        if (!digitsContainer) {
          //console.log("Nessun container di cifre trovato");
          //console.groupEnd();
          return;
        }

        // 5. Troviamo tutte le singole cifre
        const digits = digitsContainer.querySelectorAll(
          viewtype === "small" 
          ? ".countdown-timer--small-unit" 
          : ".countdown-timer--digit"
        );
        //console.log(`Trovate ${digits.length} cifre`);

        // 6. Calcoliamo il valore totale per questa unità temporale
        let totalValue = 0;
        digits.forEach((digit, digitIndex) => {
          const value = digit.getAttribute("data-value");
          const digitPos = digit.getAttribute("data-index");
          
          // Calcoliamo il valore considerando la posizione (decine/unità)
          totalValue += parseInt(value) * (digitIndex === 0 ? 10 : 1);

          //console.log(`Cifra ${digitIndex + 1}:`);
          //console.log(`- data-value: ${value}`);
          //console.log(`- data-index: ${digitPos}`);
          
          // 7. Stampiamo i valori visualizzati
          const activeDisplay = digit.querySelector('[data-transition-active="true"]');
          //console.log(`- valore visualizzato: ${activeDisplay?.textContent || "non trovato"}`);
        });

        //console.log(`Valore totale ${type}: ${totalValue}`);
        
        // 8. Aggiorniamo le etichette (giorno/giorni, ora/ore)
        const unitElement = item.querySelector(".countdown-timer--unit");
        if (unitElement) {
          const day = timer.querySelector("#sections-countdown-day").innerText;
          const days = timer.querySelector("#sections-countdown-days").innerText;
          const ora = timer.querySelector("#sections-countdown-hour").innerText;
          const ore = timer.querySelector("#sections-countdown-hours").innerText;
          if (index === 0) { // Giorni
            if(viewtype === "small"){
              unitElement.textContent = totalValue === 1 ? day.slice(0, 1) : days.slice(0, 1);
            } else {
              unitElement.textContent = totalValue === 1 ? day : days;
            }
          } else if (index === 1) { // Ore
            if(viewtype === "small") {
              unitElement.textContent = totalValue === 1 ? ora.slice(0, 1) : ore.slice(0, 1);
            } else {
              unitElement.textContent = totalValue === 1 ? ora : ore;
            }
          }
          // Minuti e secondi rimangono invariati
        }

        //console.groupEnd();
      });

      //console.groupEnd();
    });
  }

  // Aggiornamento iniziale e ogni minuto (60000 ms)
  updateTimeUnits();
  //setInterval(updateTimeUnits, 1000);
});